// @ts-nocheck
import React from "react";
import {
  FaCheckCircle,
  FaTags,
  FaArrowUp,
  FaFileAlt,
  FaCogs,
  FaUpload,
  FaChevronDown,
  FaChevronUp
} from "react-icons/fa";
import { Step } from "../../../../data/DataFile";
import "./SidebarConfigureOps.scss";

interface SidebarConfigureOpsProps {
  isDocOperationsOpen: boolean;
  selectedOperations: string[];
  onToggleDocOperations: () => void;
  currentStep: number;
  operations: Step[];
}

const SidebarConfigureOps: React.FC<SidebarConfigureOpsProps> = ({
  isDocOperationsOpen,
  selectedOperations,
  onToggleDocOperations,
  currentStep,
  operations
}) => {
  // Helper function to get icon symbol for each operation
  const getOperationIcon = (title: string) => {
    switch (title) {
      case "Attributes Extraction":
        return <FaArrowUp className="rotated" />;
      case "Document Tagging":
        return <FaTags />;
      case "Document Ingestion":
        return <FaUpload />;
      case "Similarity Search":
        return <FaCheckCircle />;
      case "Export":
        return <FaArrowUp />;
      default:
        return <FaArrowUp />;
    }
  };

  return (
    <div className="sidebar-configure-ops">
      <h2 className="step-title">
        Create Configuration
        <span className="step">Step {currentStep} of 2</span>
      </h2>

      <div className="sidebar-content">
        {/* Document Type Section */}
        <div className={`section ${currentStep === 1 ? "current-step" : ""}`}>
          <div className="icon">
            <FaFileAlt /> Document Type
          </div>
        </div>

        {/* Document Operations Section */}
        <div
          className={`section ${
            currentStep === 2 ? "current-step" : "section-active"
          }`}
          onClick={onToggleDocOperations}
          style={{ cursor: "pointer" }}
        >
          <div className="icon">
            <FaCogs /> Document Operations
          </div>
          {/* <span>
            {isDocOperationsOpen ? <FaChevronDown /> : <FaChevronUp />}
          </span> */}
        </div>

        {/* Operations List */}
        {/* {isDocOperationsOpen && (
          <ul className="operations-list">
            {operations.map((operation, i) => {
              return (
                <li key={operation.id}>
                  <div className="icon">
                    {getOperationIcon(operation.title)}
                    <span>{operation.title}</span>
                  </div>
                  {selectedOperations.includes(operation.title) && (
                    <span className="check">✓</span>
                  )}
                </li>
              );
            })}
          </ul>
        )} */}
      </div>
    </div>
  );
};

export default SidebarConfigureOps;
